import script from "./InnerPageLayout.vue?vue&type=script&setup=true&lang=ts"
export * from "./InnerPageLayout.vue?vue&type=script&setup=true&lang=ts"

import "./InnerPageLayout.vue?vue&type=style&index=0&id=52b4ea4c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b4ea4c"]])

export default __exports__